<template>
  <!-- 编辑地址页面 -->
  <div class="content">
    <div class="header">
      <van-nav-bar title="修改地址" left-arrow @click-left="$router.back()" />
    </div>
    <div class="center">
      <div>
        <img src="../../assets/img/组 8737@2x.png" alt="" />
      </div>
      <div class="hint">
        <span class="editInfo">修改收货人信息</span>
        <span @click="addressListShow = true" class="changeAddress"
          ><van-icon name="exchange" />切换地址</span
        >
      </div>
      <van-address-edit
        :address-info="addressinfo"
        show-search-result
        :show-area="false"
        :show-detail="false"
        :area-columns-placeholder="['请选择', '请选择', '请选择']"
        @save="onSave"
        save-button-text="确认修改"
      >
        <template #default>
          <van-field
            v-model="fieldValue"
            is-link
            readonly
            label="地区"
            placeholder="请选择所在地区"
            @click="show = true"
          />
          <van-popup v-model="show" round position="bottom">
            <van-cascader
              v-model="cascaderValue"
              title="请选择所在地区"
              :options="options"
              @change="onChange"
              @close="show = false"
              @finish="onFinish"
            />
          </van-popup>
          <van-field
            v-model="detailedAddress"
            label="详细地址"
            placeholder="街道门牌、楼层房间号等信息"
          />
        </template>
      </van-address-edit>
      <van-action-sheet v-model="addressListShow" class="addressListShow">
        <div class="content">
          <van-address-list
            v-model="chosenAddressId"
            :list="list"
            default-tag-text="默认地址"
            @click-item="onfirmAddress"
            @add="openAreaList"
          />
        </div>
      </van-action-sheet>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      addressID: "",
      addressListShow: false,
      chosenAddressId: "",
      list: [],
      addressinfo: {
        id: "",
        name: "",
        tel: "",
        addressDetail: "",
        county: "",
        isDefault: false,
      },
      province: "",
      city: "",
      county: "",
      street: "",
      show: false,
      fieldValue: "",
      cascaderValue: "",
      detailedAddress: "",
      options: [],
    };
  },
  created() {
    this.getcity();
    this.getAddressList();
    this.getProvince();
  },
  methods: {
    // 修改保存的事件
    async onSave(content) {
      await this.$post({
        url: "/omsRecordAddress/updateRecordAddress",
        method: "post",
        params: {
          record_address_id: this.$route.query.id,
          mobile: content.tel,
          consignee: content.name,
          province: this.province,
          city: this.city,
          district: this.county,
          street: this.street,
          address: this.detailedAddress,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.$toast.success("修改地址信息已提交!");
            this.$router.back(), (this.street = "");
            this.province = "";
            this.city = "";
            this.county = "";
            content.name = "";
            content.tel = "";
            content.isDefault = false;
          }
        })
        .catch((err) => {
          this.$toast("修改失败");
        });
    },
    // 获取默认地址信息
    async getcity() {
      this.addressID = this.$route.query.id;
      await this.$post({
        url: "/omsRecordAddress/findAddressById",
        method: "post",
        params: {
          userId: sessionStorage.getItem("EXCLUSIVE"),
          addressId: this.addressID,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            let field = res.data;
            this.addressinfo.name = field.consignee;
            this.addressinfo.tel = field.mobile;
            this.detailedAddress = field.address;
            this.province = field.province;
            this.city = field.city;
            this.county = field.district;
            this.addressinfo.isDefault = field.first_choice == 1 ? true : false;
            if (field.regionNameS) {
              this.fieldValue =
                field.regionNameP +
                field.regionNameC +
                field.regionNameD +
                field.regionNameS;
              this.street = field.street;
            } else {
              this.fieldValue =
                field.regionNameP + field.regionNameC + field.regionNameD;
            }
          }
        })
        .catch((err) => {
          this.$toast("加载失败");
        });
    },
    // 点击切换地址
    onfirmAddress(item) {
      this.addressinfo = {
        tel: item.tel,
        addressDetail: item.address,
        id: item.id,
        name: item.name,
        areaCode: item.county + "",
      };
      this.province = item.province;
      this.city = item.city;
      this.county = item.county;
      if (item.regionNameS) {
        this.fieldValue =
          item.regionNameP +
          item.regionNameC +
          item.regionNameD +
          item.regionNameS;
        this.street = item.street;
      } else {
        this.fieldValue =
          item.regionNameP + item.regionNameC + item.regionNameD;
      }
      this.detailedAddress = item.detailedAddress;
      this.addressListShow = false;
    },
    openAreaList() {
      this.addressListShow = false;
      this.areaListShow = true;
    },
    // 获取地址列表信息
    async getAddressList() {
      await this.$post({
        url: "/omsConsigneeAddress/findAll",
        method: "post",
        params: {
          userId: sessionStorage.getItem("EXCLUSIVE"),
        },
      }).then((res) => {
        if (res.retCode == 200 && res.data.code.length > 0) {
          res.data.code.map((item) => {
            if (item.regionNameS) {
              return this.list.push({
                id: item.address_id,
                name: item.consignee,
                tel: item.mobile,
                address: item.address_str,
                province: item.province,
                city: item.city,
                county: item.district,
                street: item.street,
                detailedAddress: item.address,
                regionNameP: item.regionNameP,
                regionNameC: item.regionNameC,
                regionNameD: item.regionNameD,
                regionNameS: item.regionNameS,
              });
            } else {
              return this.list.push({
                id: item.address_id,
                name: item.consignee,
                tel: item.mobile,
                address: item.address_str,
                province: item.province,
                city: item.city,
                county: item.district,
                detailedAddress: item.address,
                regionNameP: item.regionNameP,
                regionNameC: item.regionNameC,
                regionNameD: item.regionNameD,
              });
            }
          });
        } else {
          this.$toast("地址加载失败");
        }
      });
    },
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.show = false;
      this.province = selectedOptions[0].value;
      this.city = selectedOptions[1].value;
      this.county = selectedOptions[2].value;
      if (selectedOptions.length == 4) {
        this.street = selectedOptions[3].value;
      } else {
        this.street = "";
      }
      this.fieldValue = selectedOptions.map((option) => option.text).join("/");
    },
    // 点击获取市、区、镇级数据
    onChange({ value }) {
      this.$post({
        url: "/baseArea/listBaseArea",
        method: "get",
        params: {
          parentId: value,
        },
      }).then((res) => {
        if (res.retCode == 200) {
          if (res.data.code.length == 0) {
            return false;
          } else {
            // 市级数据
            if (res.data.code[0].level == 2) {
              this.options.forEach((element) => {
                element.children = [];
              });
              res.data.code.forEach((item) => {
                this.options.forEach((element) => {
                  if (element.value == item.parent_id) {
                    element.children.push({
                      text: item.name,
                      value: item.id,
                      children: [],
                    });
                  }
                });
              });
              // 区/县级数据
            } else if (res.data.code[0].level == 3) {
              this.options.forEach((element) => {
                element.children.forEach((element2) => {
                  element2.children = [];
                });
              });
              res.data.code.forEach((item) => {
                this.options.forEach((element) => {
                  element.children.forEach((element2) => {
                    if (element2.value == item.parent_id) {
                      if (item.childCount == 0) {
                        element2.children.push({
                          text: item.name,
                          value: item.id,
                        });
                      } else {
                        element2.children.push({
                          text: item.name,
                          value: item.id,
                          children: [],
                        });
                      }
                    }
                  });
                });
              });
              // 镇/街道级数据
            } else if (res.data.code[0].level == 4) {
              this.options.forEach((element) => {
                element.children.forEach((element2) => {
                  element2.children.forEach((element3) => {
                    element3.children = [];
                  });
                });
              });
              res.data.code.forEach((item) => {
                this.options.forEach((element) => {
                  element.children.forEach((element2) => {
                    element2.children.forEach((element3) => {
                      element3.children.push({
                        text: item.name,
                        value: item.id,
                      });
                    });
                  });
                });
              });
            }
          }
        } else {
          this.$toast("获取地址信息失败");
        }
      });
    },
    // 获取省级数据
    getProvince() {
      this.$post({
        url: "/baseArea/listBaseArea",
        method: "get",
      }).then((res) => {
        if (res.retCode == 200) {
          res.data.code.forEach((item) => {
            return this.options.push([
              {
                text: item.name,
                value: item.id,
                children: [],
              },
            ]);
          });
          this.options = [].concat(...this.options);
        } else {
          this.$toast("获取地址信息失败");
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  position: relative;
  background: #fafafa;
  // background-color: red;
  overflow: hidden;
  .header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    background-color: #f8f8f8;
    .van-nav-bar {
      background-color: #40000000;
      /deep/.van-nav-bar__text {
        color: #030303;
        font-size: 0.45rem;
      }
      /deep/.van-nav-bar__left {
        .van-icon {
          color: #030303;
          font-size: 0.533333rem;
          vertical-align: middle;
        }
      }
      /deep/.van-nav-bar__title.van-ellipsis {
        font-weight: 600 !important;
      }
    }
  }
  .center {
    height: 100%;
    background-color: #1f000000;
    padding-top: 0.83rem;
    .hint {
      padding: 0 0.37rem;
      margin-top: 0.59rem;
      overflow: hidden;
      .editInfo {
        float: left;
        font-size: 0.43rem;
        font-weight: 700;
        color: #000;
      }
      .changeAddress {
        float: right;
        font-size: 0.37rem;
        i {
          vertical-align: middle;
        }
      }
    }
    img {
      width: 9.25rem;
      height: 1.74rem;
      display: block;
      margin: 0 auto;
      margin-top: 1rem;
    }
    .van-checkbox {
      background-color: #ffffff;
      border-radius: 0.21rem;
      margin-bottom: 0.27rem;
      /deep/.van-checkbox__icon.van-checkbox__icon--round {
        display: none;
      }
    }
    .van-address-edit {
      position: relative;
      /deep/.van-button {
        margin-top: 3rem;
        background-color: #fc563a;
        border-color: #fc563a;
      }
      /deep/.van-address-edit__buttons {
        padding-bottom: 0 !important;
      }
    }
    .addressListShow {
      min-height: 12rem;
      overflow: hidden;
      background-color: #f5f5f5;
      .van-action-sheet__content {
        margin-top: 1rem;
        /deep/.van-icon.van-icon-success {
          display: none;
        }
        /deep/.van-icon.van-icon-edit.van-address-item__edit {
          display: none;
        }
      }
      .content {
        .van-address-list__bottom {
          display: none;
        }
        /deep/.van-address-list {
          background-color: #f5f5f5;
        }
        // /deep/.van-address-list {
        //   overflow-y: auto;
        // }
        .van-button {
          margin: 0 auto;
          width: 5rem;
          border-radius: 0.15rem;
          background-color: #f74b2e;
          border-color: #f74b2e;
        }
      }
    }
  }
}
</style>
